export default {
  '组织结构列表':'组织结构列表',
  '请输入名称\代码':'请输入名称\代码',
  '管理成员':'管理成员',
  '组织结构名称':'组织结构名称',
  '上级组织':'上级组织',
  '组织代码':'组织代码',
  '添加成员':'添加成员',
  '组织结构':'组织结构',
  '组织结构代码需为两位':'组织结构代码需为两位',
  '新增组织结构':'新增组织结构',
  '编辑组织结构':'编辑组织结构',
  '确认要删除该组织结构：{departmentName}？':'确认要删除该组织结构：{departmentName}？',
  '取消全部选中':'取消全部选中',
  '是否确认批量移除{selectedUser}名成员？':'是否确认批量移除{selectedUser}名成员？',
  '是否确认移除成员{accountName}？':'是否确认移除成员{accountName}？',

  '确认要删除该机构：{tenantOrgName}？':'确认要删除该机构：{tenantOrgName}？',
  '确认要停用该机构：{tenantOrgName}？':'确认要停用该机构：{tenantOrgName}？',
  '确认要启用该机构：{tenantOrgName}？':'确认要启用该机构：{tenantOrgName}？',
  '停用该机构将会停用下层级机构':'停用该机构将会停用下层级机构',  
}